import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { disposeTheNodeHaveNoChild } from '../../utils/toolsForCommon'
import Vue from 'vue'
let vm: any = new Vue()

@Module({ name: 'Common', namespaced: true, stateFactory: true })
export default class Common extends VuexModule {
  public treeDataForOrganatizion: any[] = []
  public treeDataForSubOrganatizion: any[] = []

  // 设置组织架构--整体：
  @Mutation
  public setTreeDataForOrganization (treeDataForOrganatizion: any) {
    this.treeDataForOrganatizion = treeDataForOrganatizion
  }

  // 设置组织架构--子树：
  @Mutation
  public setTreeDataForSubOrganization (treeDataForSubOrganatizion: any) {
    this.treeDataForSubOrganatizion = treeDataForSubOrganatizion
  }

  // 获取组织架构--整体：
  @Action
  public getTreeDataForOrganization () {
    return new Promise(async (resolve, reject) => {
      try {
        const { data: result } = await vm.$http.getTreeDataForOrganization()
        if (result.code !== 200) return reject(result.msg)
        const treeDataForOrganatizion = disposeTheNodeHaveNoChild([result.data], 'children')
        this.setTreeDataForOrganization(treeDataForOrganatizion)
        resolve(treeDataForOrganatizion)
      } catch (err) {
        console.log(err)
      }
    })
  }

  // 获取组织架构--子树：
  @Action
  public getTreeDataForSubOrganization () {
    return new Promise(async (resolve, reject) => {
      try {
        let { data: result } = await vm.$http.getTreeDataForSubOrganization()
        if (result.code !== 200) return reject(result.msg)
        const treeDataForSubOrganatizion = disposeTheNodeHaveNoChild([result.data], 'children')
        this.setTreeDataForSubOrganization(treeDataForSubOrganatizion)
        resolve(treeDataForSubOrganatizion)
      } catch (err) {
        console.log(err)
      }
    })
  }
}
